import { Component } from 'react';
import { connect } from 'react-redux';

import Home from '../home/';
import { Helmet } from 'react-helmet';
import { set } from 'actions/configuration';

class ChevroletHome extends Component {
  constructor(props) {
    super(props);

    this.props.set({
      brand: 'gm',
      style: 'yellow',
      brand_id: 2,
      legacy_service_option: false,
    });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Yacopini Motors - Turnos de taller Chevrolet</title>
          <meta
            name="description"
            content="Turnos de taller/postventa para tu vehículo Chevrolet."
          />
          <link rel="icon" href="favicon-gm.ico" type="image/ico" />
        </Helmet>
        <Home />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    set: config => {
      dispatch(set(config));
    },
  };
};

export default connect(null, mapDispatchToProps)(ChevroletHome);
